﻿import * as paths from './paths';
export default class ThematicConfigurator {
    constructor(configContainer, rootURL, settings, resourcesHandler, additional) {
        this.resourcesHandler = resourcesHandler;
        this.configContainer = configContainer;
        this.rootURL = rootURL;
        this.settings = settings;
        this.entityId = 'entity-id';
        this.entityFieldId = 'entity-field-id';
        this.colorPickersId = 'color-pickers-id';
        this.opacityId = 'opacity-id';
        this.thematicTypeId = 'thematic-type-id';
        this.colorRampWrapperId = 'color-ramp-wrapper-id';
        this.colorIntervalWrapperId = 'color-interval-wrapper-id';
        this.valueAutoId = 'value-auto-id';
        this.colorRampContainerId = 'color-ramp-container-id';
        this.numberOfRampsId = 'number-of-ramps-id';
        this.generateRampButton = 'generate-ramp-button';
        this.colorIntervalContainerId = 'color-interval-container';
        this.colorIntervalContainerInnerId = 'color-interval-container-inner';
        this.additional = additional;
    }

    save() {
        let ramps = [];

        let rampInputs = $('.ramp-color');

        for (let i = 0; i < rampInputs.length; i++) {
            ramps.push(rampInputs[i].value);
        }

        let intervals = [];

        let createdIntervals = $('.interval-row');

        for (let i = 0; i < createdIntervals.length; i++) {
            let createdInterval = $(createdIntervals[i]);
            let min = createdInterval.find('input.interval-min:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').value();
            let max = createdInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').value();
            let color = createdInterval.find('.interval-color').val();

            intervals.push({
                min: min,
                max: max,
                color: color
            });
        }

        return {
            IdEntity: $('#' + this.entityId).data("kendoComboBox").value(),
            IdEntityField: $('#' + this.entityFieldId).data('kendoComboBox').value(),
            NameEntityField: $('#' + this.entityFieldId).data('kendoComboBox').text(),
            Opacity: $("#" + this.opacityId).data('kendoNumericTextBox').value(),
            AutoValues: $('#' + this.valueAutoId).data('kendoSwitch').check(),
            Ramp: ramps,
            Intervals: intervals,
            Type: 'TEMATIC'
        };
    }

    init() {
        this.configContainer.innerHTML = this._getTemplate();

        if (this.additional == null || this.additional.idEntity == null) {
            $('#' + this.entityId).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                popup: {
                    appendTo: $(this.configContainer)
                },
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return this.rootURL + paths.MAP_ENTITY_LAYERS;
                            }
                        }
                    }
                },
                change: (evt) => {
                    $('#' + this.entityFieldId).data("kendoComboBox").value(null);
                    $('#' + this.entityFieldId).data("kendoComboBox").dataSource.read();
                }
            });

            if (this.settings.IdEntity) {
                $('#' + this.entityId).data("kendoComboBox").value(this.settings.IdEntity);
            }
        } else {
            $('#' + this.entityId).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                popup: {
                    appendTo: $(this.configContainer)
                },
                dataSource: []
            });

            $('#' + this.entityId).data("kendoComboBox").value(this.additional.idEntity);
            $('#id-entity-wrapper').hide();
        }

        if (this.additional == null || this.additional.fields == null) {
            $('#' + this.entityFieldId).kendoComboBox({
                dataTextField: 'FieldName',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                popup: {
                    appendTo: $(this.configContainer)
                },
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return this.rootURL + paths.MAP_ENTITY_GET_STATISTICAL_FIELDS + $('#' + this.entityId).data('kendoComboBox').value();
                            }
                        }
                    }
                }
            });

            if (this.settings.IdEntityField != null) {
                $('#' + this.entityFieldId).data('kendoComboBox').value(this.settings.IdEntityField);
            }
        } else {
            $('#' + this.entityFieldId).kendoComboBox({
                dataTextField: 'FieldName',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                popup: {
                    appendTo: $(this.configContainer)
                },
                dataSource: this.additional.fields
            });

            if (this.settings.IdEntityField != null) {
                $('#' + this.entityFieldId).data('kendoComboBox').value(this.settings.IdEntityField);
            }
        }

        $("#" + this.opacityId).kendoNumericTextBox({
            min: 0,
            max: 1,
            appendTo: '#' + this.opacityId
        });

        if (this.settings.Opacity != null) {
            $("#" + this.opacityId).data('kendoNumericTextBox').value(this.settings.Opacity);
        } else {
            $("#" + this.opacityId).data('kendoNumericTextBox').value(1);
        }

        $('#' + this.valueAutoId).kendoSwitch({
            messages: {
                checked: this.resourcesHandler.get('SWITCH_ON'),
                unchecked: this.resourcesHandler.get('SWITCH_OFF')
            },
            checked: this.settings.AutoValues == null ? true : this.settings.AutoValues,
            change: evt => {
                if (evt.sender.check()) {
                    $('.interval-input').hide();
                    $('.interval-row').removeClass('col-12');
                    $('.add-interval-wrapper').removeClass('col-12');
                    $('#color-interval-container-inner').removeClass('pl-0');
                    $('#color-interval-container-inner').addClass('pl-1');
                    $('.remove-interval-color-id').css('margin-left', '1.4rem');
                    $($('.remove-interval-color-id')[0]).css('margin-left', '0.75rem');
                    $('.add-interval-color-id').css('margin-left', '0.9rem');
                } else {
                    $('.interval-input').show();
                    $('.interval-row').addClass('col-12');
                    $('.add-interval-wrapper').addClass('col-12');
                    $('#color-interval-container-inner').addClass('pl-0');
                    $('#color-interval-container-inner').removeClass('pl-1');
                    $('.remove-interval-color-id').css('margin-left', '0.75rem');
                    $($('.remove-interval-color-id')[0]).css('margin-left', '0.75rem');
                    $('.add-interval-color-id').css('margin-left', '0.75rem');
                }
            }
        });

        if (this.settings.Ramp == null || this.settings.Ramp.length == 0) {
            this.settings.Ramp = ['#00FF00', '#FFFF00'];
        }

        let template = `<label class="form-label pt-2">` + this.resourcesHandler.get('InputColorIntervals') + `:</label>`;

        for (let i = 0; i < this.settings.Ramp.length; i++) {
            template += `<div class="mb-3 d-flex pt-1">
                <i class="fal fa-times remove-color-id" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: red; font-size: 0.9rem; margin-left: 0.75rem;"></i>
                <input class="ramp-color custom-color" type="color" value="` + this.settings.Ramp[i] + `">
            </div>`;
        }

        template += `<i class="fal fa-plus add-color-id pt-1" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: green; font-size: 0.9rem; margin-left: 0.5rem;">
                    </i>
                    <div class="col-1 mb-3">
                        <div class="form-group">
                            <input class="form-control" id="` + this.numberOfRampsId + `" placeholder="` + this.resourcesHandler.get('NumberOfRamps') + `">
                        </div>
                    </div>
                    <button id="` + this.generateRampButton + `" class="btn btn-primary" style="height: 2.25rem;">` + this.resourcesHandler.get('Generate') + `</button>`;

        $('#' + this.colorRampContainerId)[0].innerHTML = template;

        $('#' + this.colorRampContainerId).on('click', evt => {
            if (evt.target.classList.contains('add-color-id')) {
                let template = `<div class="mb-3 d-flex pt-1">
                                    <i class="fal fa-times remove-color-id" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: red; font-size: 0.9rem; margin-left: 0.75rem;"></i>
                                    <input class="ramp-color custom-color" type="color" value="#ffffff">
                                </div>`;

                $($(evt.target).parent().children()[$(evt.target).parent().children().length - 4]).after(template);

                $("#" + this.numberOfRampsId).data('kendoNumericTextBox').min($('.ramp-color').length);

                if ($("#" + this.numberOfRampsId).data('kendoNumericTextBox').value() < $('.ramp-color').length) {
                    $("#" + this.numberOfRampsId).data('kendoNumericTextBox').value($('.ramp-color').length);
                }
            } else if (evt.target.classList.contains('remove-color-id')) {
                $(evt.target).parent().remove();
                $("#" + this.numberOfRampsId).data('kendoNumericTextBox').min($('.ramp-color').length);

                if ($("#" + this.numberOfRampsId).data('kendoNumericTextBox').value() < $('.ramp-color').length) {
                    $("#" + this.numberOfRampsId).data('kendoNumericTextBox').value($('.ramp-color').length);
                }
            }
        });

        $("#" + this.numberOfRampsId).kendoNumericTextBox({
            format: "0",
            decimals: 0,
            min: this.settings.Ramp.length
        });

        $("#" + this.numberOfRampsId).data('kendoNumericTextBox').value(this.settings.Ramp.length);

        $('#' + this.generateRampButton).on('click', () => {
            let colors = [];

            let colorInputs = $('.ramp-color');

            for (let i = 0; i < colorInputs.length; i++) {
                colors.push(colorInputs[i].value);
            }

            let intervals = this._generateIntervals(colors, $("#" + this.numberOfRampsId).data('kendoNumericTextBox').value());
            this._setIntervals(intervals, !$('#' + this.valueAutoId).data('kendoSwitch').check());
        });

        if (this.settings.Intervals != null && this.settings.Intervals.length > 0) {
            this._setIntervals(this.settings.Intervals, !$('#' + this.valueAutoId).data('kendoSwitch').check());
        }
    }

    _setIntervals(intervals, showInputs) {
        let template = `<label class="form-label">` + this.resourcesHandler.get('RampColorIntervals') + `:</label>
                        <div class="form-row ml-0 mt-1 col-12` + (showInputs ? ` pl-0` : ` pl-1`) + ` pr-0" id="` + this.colorIntervalContainerInnerId + `">`;
        for (let i = 0; i < intervals.length; i++) {
            template += `<div class="form-row` + (showInputs ? ` col-12` : ``) + ` interval-row">
                            <i class="fal fa-times remove-interval-color-id pt-1" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: red; font-size: 0.9rem; margin-left: ` + (showInputs || i == 0 ? `0.75rem` : `1.4rem`) + `;"></i>
                            <input class="interval-color mt-1 custom-color" type="color" value="` + intervals[i].color + `">
                            <div class="form-group col-1 mb-2 interval-input"` + (showInputs ? ``: ` style="display: none;"`) + `>
                                <input class="interval-min form-control" placeholder="min">
                            </div>
                            <div class="form-group col-1 mb-2 interval-input"` + (showInputs ? `` : ` style="display: none;"`) + `>
                                <input class="interval-max form-control" placeholder="max">
                            </div>
                        </div>`;
        }

        template += `<div class="form-row` + (showInputs ? ` col-12` : ``) + ` add-interval-wrapper">
                        <i class="fal fa-plus add-interval-color-id pt-1" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: green; font-size: 0.9rem; margin-right: 1.65rem; margin-left: ` + (showInputs ? `0.75rem` : `1.1rem`) + `;"></i>
                    </div>`;

        template += `</div>`;

        $('#' + this.colorIntervalContainerId)[0].innerHTML = template;

        let createdIntervals = $('.interval-row');

        for (let i = 0; i < createdIntervals.length; i++) {
            let createdInterval = $(createdIntervals[i]);

            createdInterval.find('.interval-min').kendoNumericTextBox({});

            if (createdInterval.min != null) {
                createdInterval.find('input.interval-min:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').value(createdInterval.min);
            }

            createdInterval.find('.interval-max').kendoNumericTextBox({});

            if (createdInterval.max != null) {
                createdInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').value(createdInterval.max);
            }

            if (i == 0) {
                createdInterval.find('input.interval-min:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(true);
                createdInterval.find('input.interval-min').attr('placeholder', 'auto');
            }

            if (i == createdIntervals.length - 1) {
                createdInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(true);
                createdInterval.find('input.interval-max').attr('placeholder', 'auto');
            }
        }

        $('#' + this.colorIntervalContainerInnerId).on('click', (evt) => {
            if (evt.target.classList.contains('remove-interval-color-id')) {
                $($(evt.target).parent()).remove();

                let remainingIntervals = $('.interval-row');

                for (let i = 0; i < remainingIntervals.length; i++) {
                    let remainingInterval = $(remainingIntervals[i]);

                    if (i == 0) {
                        remainingInterval.find('input.interval-min:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(true);
                        remainingInterval.find('input.interval-min').attr('placeholder', 'auto');
                    }

                    if (i == remainingIntervals.length - 1) {
                        remainingInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(true);
                        remainingInterval.find('input.interval-max').attr('placeholder', 'auto');
                    }
                }

            } else if (evt.target.classList.contains('add-interval-color-id')) {
                let intervalRowTemplate = `<div class="form-row` + (showInputs ? ` col-12` : ``) + ` interval-row">
                            <i class="fal fa-times remove-interval-color-id pt-1" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: red; font-size: 0.9rem; margin-left: ` + (showInputs ? `0.75rem` : `1.4rem`) + `;"></i>
                            <input class="interval-color mt-1 custom-color" type="color" value="#ffffff">
                            <div class="form-group col-1 mb-2 interval-input"` + (showInputs ? `` : ` style="display: none;"`) + `>
                                <input class="interval-min form-control" placeholder="min">
                            </div>
                            <div class="form-group col-1 mb-2 interval-input"` + (showInputs ? `` : ` style="display: none;"`) + `>
                                <input class="interval-max form-control" placeholder="max">
                            </div>
                        </div>`;

                $($(evt.target).parent().parent().children()[$(evt.target).parent().parent().children().length - 2]).after(intervalRowTemplate);

                let createdIntervals = $('.interval-row');

                let createdInterval = $(createdIntervals[createdIntervals.length - 1]);
                let previousInterval = $(createdIntervals[createdIntervals.length - 2]);

                createdInterval.find('.interval-min').kendoNumericTextBox({});
                createdInterval.find('.interval-max').kendoNumericTextBox({});

                createdInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(true);
                createdInterval.find('input.interval-max').attr('placeholder', 'auto');

                previousInterval.find('input.interval-max:not(.k-formatted-value)[data-role="numerictextbox"]').data('kendoNumericTextBox').readonly(false);
                previousInterval.find('input.interval-max').attr('placeholder', 'max');
            }
        });
    }

    _generateIntervals(colors, count) {
        let result = [];

        let remaining = count - colors.length;

        let shades = [];

        for (let i = 0; i < colors.length - 1; i++) {
            shades.push(0);
        }

        for (let i = 0; i < remaining; i++) {
            shades[i % shades.length]++;
        }

        result.push({ min: null, max: null, color: colors[0] });

        for (let i = 1; i < colors.length; i++) {
            let firstColor = colors[i - 1];
            let secondColor = colors[i];

            if (shades[i - 1] > 0) {
                let generated = this._generateColor(firstColor, secondColor, shades[i - 1] + 1).reverse();

                for (let j = 1; j < generated.length; j++) {
                    result.push({ min: null, max: null, color: generated[j] });
                }
            }

            result.push({ min: null, max: null, color: secondColor });
        }

        return result;
    }

    _generateColor(colorStart, colorEnd, colorCount) {
        var start = this._convertToRGB(colorStart);
        var end = this._convertToRGB(colorEnd);
        var len = colorCount;
        var alpha = 0.0;

        var saida = [];

        for (let i = 0; i < len; i++) {
            var c = [];
            alpha += (1.0 / len);

            c[0] = start[0] * alpha + (1 - alpha) * end[0];
            c[1] = start[1] * alpha + (1 - alpha) * end[1];
            c[2] = start[2] * alpha + (1 - alpha) * end[2];

            saida.push('#' + this._convertToHex(c));

        }

        return saida;
    }

    _convertToRGB(hex) {
        var color = [];
        color[0] = parseInt((this._trim(hex)).substring(0, 2), 16);
        color[1] = parseInt((this._trim(hex)).substring(2, 4), 16);
        color[2] = parseInt((this._trim(hex)).substring(4, 6), 16);
        return color;
    }

    _trim(s) {
        return (s.charAt(0) == '#') ? s.substring(1, 7) : s
    }

    _convertToHex(rgb) {
        return this._hex(rgb[0]) + this._hex(rgb[1]) + this._hex(rgb[2]);
    }

    _hex(c) {
        var s = "0123456789abcdef";
        var i = parseInt(c);

        if (i == 0 || isNaN(c))
            return "00";

        i = Math.round(Math.min(Math.max(0, i), 255));
        return s.charAt((i - i % 16) / 16) + s.charAt(i % 16);
    }

    _getTemplate() {
        return `<div class="form-group col-12">
                    <div class="form-row">
                        <div class="col-6" id="id-entity-wrapper">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('Entity') + `</label>
                                <div class="form-control" id="` + this.entityId + `"></div>
                            </div>
                        </div>
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('ThematicField') + `</label>
                                <input class="form-control" id="` + this.entityFieldId + `">
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-3">
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('Opacity') + `</label>
                                <input class="form-control" id="` + this.opacityId + `">
                            </div>
                        </div>
                        <div class="col-6 mb-3 align-content-center pt-4">
                            <div class="form-group" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                                <label class="form-label ml-1">` + this.resourcesHandler.get('ColorIntervalsAuto') + `</label>
                                <div id="` + this.valueAutoId + `"></div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row ml-0" id="` + this.colorRampContainerId + `">
                    </div>
                    <div class="form-row ml-0 mt-1" id="` + this.colorIntervalContainerId + `">
                    </div>
                </div>`;
    }
}